import React, { useCallback } from "react";
import "./formik-number-input.scss";
import classNames from "classnames";
import { useField } from "formik";
import InputUnstyled from "@mui/base/InputUnstyled";
import { ValidationError } from "@thrivetribe/mvf.ui.atoms.validation-error";
import { FlagGB } from "@thrivetribe/mvf.assets.icons.flags";

export type FormikNumberInputProps = {
  name: string;
  placeholder?: string;
  className?: string;
  label?: string;
  errorMessage?: string;
  phoneNumStyling?: boolean;
  [key: string]: any;
};

export const FormikNumberInput: React.FC<FormikNumberInputProps> = ({
  className,
  label,
  errorMessage,
  name,
  phoneNumStyling,
  ...rest
}: FormikNumberInputProps) => {
  const [field, meta, helpers] = useField({ name, type: "number", ...rest });

  const onChange = React.useCallback(
    (event) => {
      let value = event.target.value;
      if (value !== "" && rest.pattern) {
        const regex = rest.pattern;
        value = value.match(regex)[0];
      }
      helpers.setValue(value);
    },
    [rest.pattern]
  );

  return (
    <>
      <label className="text-input__label">
        {label}
        <div className={phoneNumStyling ? "phone-input__container" : ""}>
          {phoneNumStyling && (
            <div
              className={`
                phone-input__wrapper
                ${!!meta.error && meta.touched ? "Mui-error" : ""}
              `}
            >
              <div className="phone-input__country">
                <FlagGB />
                <span>+44</span>
              </div>
            </div>
          )}
          <InputUnstyled
            {...field}
            className={classNames("text-input", className)}
            error={!!meta.error && meta.touched}
            onChange={onChange}
            {...rest}
          />
        </div>
        {meta.error != undefined && meta.touched && (
          <ValidationError errorMessage={meta.error} />
        )}

        {!meta.error && meta.touched && errorMessage && (
          <ValidationError errorMessage={errorMessage} />
        )}
      </label>
    </>
  );
};
